import React, { useState, useEffect, useRef } from 'react';
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { useLocation, useNavigate } from 'react-router-dom';
import DefaultData from '../../CompanyData/DefaultData';
import useAirportList, { searchAirportList } from './useAirportList';
import './Flight.css';
const ModifyFlightSearch = ({onSearch}) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { airports, loading: airportListLoading, error: airportListError } = useAirportList();
    const [departureDate, setDepartureDate] = useState(new Date())
    const [returnDate, setReturnDate] = useState(new Date())
    const [departureResults, setDepartureResults] = useState([]);
    const [arrivalResults, setArrivalResults] = useState([]);
    const [departureSuggestionsOpen, setDepartureSuggestionsOpen] = useState(false);
    const [arrivalSuggestionsOpen, setArrivalSuggestionsOpen] = useState(false);
    const [locationFrom, setLocationFrom] = useState('HYD');
    const [locationTo, setLocationTo] = useState('BOM');
    const [displayFrom, setDisplayFrom] = useState('Hyderabad(HYD), India');
    const [displayTo, setDisplayTo] = useState('Mumbai(BOM), India');
    const [selectedDeparture, setSelectedDeparture] = useState(null);
    const [selectedArrival, setSelectedArrival] = useState(null);
    const [from, setFrom] = useState('Hyderabad, India');
    const [to, setTo] = useState('Mumbai, India');
    const [searchQuery, setSearchQuery] = useState({});
    const [trips, setTrips] = useState([
        { from: "HYD, India", to: "BOM, India", locationFrom: "HYD", locationTo: "BOM", displayFrom: "Hyderabad(HYD)", displayTo: "Mumbai(BOM)", cityFrom: "Hyderabad", cityTo: "Mumbai", departureDate: new Date(), departureResults: [], arrivalResults: [] },
    ]);
    const [adults, setAdults] = useState(1);
    const [kids, setKids] = useState(0);
    const [infants, setInfants] = useState(0);
    const [cabinClass, setCabinClass] = useState("ECONOMY");
    const [errors, setErrors] = useState({});
    const [journeyType, setJourneyType] = useState("ONEWAY");
    const inputDRef = useRef(null);
    const inputARef = useRef(null);

    const validate = () => {
        let temp = {};
        temp.from = from === "" ? false : true;
        temp.to = to === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleDepartureAirportSearch = (e) => {
        const value = e.target.value;
        setDisplayFrom(value);
        setFrom("");
        setSelectedDeparture(null);
        setDepartureSuggestionsOpen(true);
        setDepartureResults(airportListLoading ? [] : searchAirportList(airports, value, selectedArrival?.airportCode));
    };
    const handleDepartureAirportClick = (e) => {
        setArrivalResults([]);
        setArrivalSuggestionsOpen(false);
        setDepartureSuggestionsOpen(true);
        setDepartureResults(searchAirportList(airports, "", selectedArrival?.airportCode));
        inputDRef.current?.select();
    };
    const handleDepartureSelect = (data) => {
        if (selectedArrival && selectedArrival.airportCode === data.airportCode) {
            alert("Departure and arrival airports cannot be the same.");
            setSelectedArrival(null);
            setDisplayTo(""); // Clear arrival input
            return;
        } else {
            var DF = data.cityName + "(" + data.airportCode + "), " + data.countryName;
            setDisplayFrom(DF);
            setLocationFrom(data.airportCode);
            setFrom(data.cityName);
            setSelectedDeparture(data);
            setDepartureResults([]);
            setDepartureSuggestionsOpen(false);
        }
    }
    const handleArrivalAirportSearch = (e) => {
        const value = e.target.value;
        setDisplayTo(value);
        setTo("");
        setSelectedArrival(null);
        setArrivalSuggestionsOpen(true);
        setArrivalResults(airportListLoading ? [] : searchAirportList(airports, value, selectedDeparture?.airportCode));
    };
    const handleArrivalSelect = (data) => {
        if (selectedDeparture && selectedDeparture.airportCode === data.airportCode) {
            alert("Arrival and departure airports cannot be the same.");
            setSelectedDeparture(null);
            setDisplayFrom(""); // Clear departure input
            return;
        }
        else {
            var DF = data.cityName + "(" + data.airportCode + "), " + data.countryName;
            setDisplayTo(DF);
            setLocationTo(data.airportCode)
            setTo(data.cityName);
            setSelectedArrival(data);
            setArrivalResults([]);
            setArrivalSuggestionsOpen(false);
        }
    }
    const handleArrivalAirportClick = (e) => {
        setDepartureResults([]);
        setDepartureSuggestionsOpen(false);
        setArrivalSuggestionsOpen(true);
        setArrivalResults(searchAirportList(airports, "", selectedDeparture?.airportCode));
        inputARef.current?.select();
    };
    const handleClassType = (e) => {
        setCabinClass(e.target.value)
    }
    const handleIncreaseAdults = (e) => {
        e.stopPropagation();
        setAdults(parseFloat(adults + 1))
    }
    const handleDecreaseAdults = (e) => {
        e.stopPropagation();
        if (adults !== 1) {
            setAdults(parseFloat(adults - 1))
        }
    }
    const handleIncreaseKids = (e) => {
        e.stopPropagation();
        setKids(parseFloat(kids + 1))
    }
    const handleDecreaseKids = (e) => {
        e.stopPropagation();
        if (kids !== 0) {
            setKids(parseFloat(kids - 1))
        }
    }
    const handleIncreaseInfants = (e) => {
        e.stopPropagation();
        setInfants(parseFloat(infants + 1))
    }
    const handleDecreaseInfants = (e) => {
        e.stopPropagation();
        if (infants !== 0) {
            setInfants(parseFloat(infants - 1))
        }
    }
    const handleDepartureDate = (date) => {
        const selectedDate = date[0];
        setDepartureDate(selectedDate);

        // If returnDate is before the new departureDate, reset it to departureDate
        if (returnDate && selectedDate && returnDate < selectedDate) {
            setReturnDate(selectedDate);
        }
    };
    const handleReturnDate = (date) => {
        setReturnDate(date[0]);
    };
    const handleJourneyType = (e) => {
        e.preventDefault();
        setJourneyType(e.currentTarget.dataset.journeyType);
    }
    function GetFlightDestinations() {
        const fvalues = [];
        for (var i = 0; i < trips.length; i++) {
            fvalues.push({ from: locationFrom, to: locationTo, departureDate: moment(departureDate).format('YYYY-MM-DD'), returnDate: moment(returnDate).format('YYYY-MM-DD') });
        }
        return fvalues;
    }
    const handleSearch = (e) => {
        e.preventDefault();
        if (validate()) {
            const searchQuery = {
                "journeyType": journeyType,
                "isDomestic": "DOMESTIC",
                "adults": adults,
                "kids": kids,
                "infants": infants,
                "cabinClass": cabinClass,
                "companyId": DefaultData?.DEFAULTCOMPANYID,
                "preferred": "REGULAR",
                "isDirectFlight": false,
                "isConnectingFlight": false,
                "flightTravelerPoints": GetFlightDestinations(),
            }
            onSearch(searchQuery);
            navigate('/flight/' + adults + "/" + kids + "/" + infants + "/DOMESTIC", {
                replace: true,
                state: { searchQuery } 
            });
        }
    }
    useEffect(() => {
        if (airportListLoading || !state?.searchQuery) return;

        setSearchQuery(state.searchQuery);
        setJourneyType(state.searchQuery.journeyType || "ONEWAY")
        setCabinClass(state.searchQuery.cabinClass || "ECONOMY")
        setAdults(state.searchQuery.adults || 1);
        setKids(state.searchQuery.kids || 0);
        setInfants(state.searchQuery.infants || 0);
        const dAirports = airports.find(c => c.airportCode === state.searchQuery?.flightTravelerPoints[0]?.from)
        const DF = dAirports ? `${dAirports.cityName}(${dAirports.airportCode}), ${dAirports.countryName}` : "";
        setLocationFrom(dAirports?.airportCode)
        setDisplayFrom(DF)
        setFrom(dAirports?.cityName || "");
        const rAirports = airports.find(c => c.airportCode === state.searchQuery?.flightTravelerPoints[0]?.to)
        const DR = rAirports ? `${rAirports.cityName}(${rAirports.airportCode}), ${rAirports.countryName}` : "";
        setLocationTo(rAirports?.airportCode || "");
        setDisplayTo(DR)
        setTo(rAirports?.cityName || "");
        setDepartureDate(new Date(state.searchQuery?.flightTravelerPoints[0]?.departureDate))
        setReturnDate(new Date(state.searchQuery?.flightTravelerPoints[0]?.returnDate))
    }, [airportListLoading, airports, state]);

    useEffect(() => {
        if (airportListLoading) return;
        if (departureSuggestionsOpen) {
            setDepartureResults(searchAirportList(airports, displayFrom, selectedArrival?.airportCode));
        }
        if (arrivalSuggestionsOpen) {
            setArrivalResults(searchAirportList(airports, displayTo, selectedDeparture?.airportCode));
        }
    }, [airportListLoading, airports, departureSuggestionsOpen, arrivalSuggestionsOpen, displayFrom, displayTo, selectedArrival, selectedDeparture]);
    return (
        <section className="modify-flight-search">
            <div className="modify-flight-search-heading">
                <div>
                    <span className="modify-flight-search-eyebrow">Refine your trip</span>
                    <h2>Modify search</h2>
                </div>
                <div className="modify-flight-trip-types" aria-label="Trip type">
                    <button type="button" data-journey-type="ONEWAY" className={journeyType === "ONEWAY" ? "active" : ""} onClick={handleJourneyType}>One way</button>
                    <button type="button" data-journey-type="RETURN" className={journeyType === "RETURN" ? "active" : ""} onClick={handleJourneyType}>Round trip</button>
                </div>
            </div>
            <div className="modify-flight-fields">
                <div className="modify-flight-field modify-flight-location">
                    <label htmlFor="modifyFrom"><i className="ri-flight-takeoff-line" /> From</label>
                    <div className="flight-airport-autocomplete">
                        <input id="modifyFrom" ref={inputDRef} className="form-control" type="text" placeholder="City or airport" value={displayFrom} autoComplete="off" aria-autocomplete="list" aria-expanded={departureSuggestionsOpen} onChange={handleDepartureAirportSearch} onClick={handleDepartureAirportClick} onFocus={handleDepartureAirportClick} />
                        {departureSuggestionsOpen && (
                            <ul className="flight-airport-suggestions" role="listbox" aria-label="Departure airports">
                                {airportListLoading ? <li className="flight-airport-message">Loading airports...</li> : airportListError ? <li className="flight-airport-message flight-airport-error">{airportListError}</li> : departureResults.length ? departureResults.map((airport) => (
                                    <li key={`${airport.airportCode}-${airport.cityName}`} role="option" aria-selected="false">
                                        <button type="button" className="flight-airport-option" onMouseDown={(e) => e.preventDefault()} onClick={() => handleDepartureSelect(airport)}>
                                            <span className="flight-airport-option-icon"><i className="ri-map-pin-line" aria-hidden="true" /></span>
                                            <span className="flight-airport-option-copy">
                                                <span className="flight-airport-option-title">{airport.cityName}</span>
                                                <span className="flight-airport-option-subtitle">{airport.airportName} · {airport.countryName}</span>
                                            </span>
                                            <span className="flight-airport-option-code">{airport.airportCode}</span>
                                        </button>
                                    </li>
                                )) : <li className="flight-airport-message">No matching airports found</li>}
                            </ul>
                        )}
                    </div>
                    {errors.from === false ? (<div className="validationerror">Please select departure</div>) : null}
                </div>
                <div className="modify-flight-field modify-flight-location">
                    <label htmlFor="modifyTo"><i className="ri-flight-land-line" /> To</label>
                    <div className="flight-airport-autocomplete">
                        <input id="modifyTo" ref={inputARef} className="form-control" type="text" placeholder="City or airport" value={displayTo} autoComplete="off" aria-autocomplete="list" aria-expanded={arrivalSuggestionsOpen} onChange={handleArrivalAirportSearch} onClick={handleArrivalAirportClick} onFocus={handleArrivalAirportClick} />
                        {arrivalSuggestionsOpen && (
                            <ul className="flight-airport-suggestions" role="listbox" aria-label="Arrival airports">
                                {airportListLoading ? <li className="flight-airport-message">Loading airports...</li> : airportListError ? <li className="flight-airport-message flight-airport-error">{airportListError}</li> : arrivalResults.length ? arrivalResults.map((airport) => (
                                    <li key={`${airport.airportCode}-${airport.cityName}`} role="option" aria-selected="false">
                                        <button type="button" className="flight-airport-option" onMouseDown={(e) => e.preventDefault()} onClick={() => handleArrivalSelect(airport)}>
                                            <span className="flight-airport-option-icon"><i className="ri-map-pin-line" aria-hidden="true" /></span>
                                            <span className="flight-airport-option-copy">
                                                <span className="flight-airport-option-title">{airport.cityName}</span>
                                                <span className="flight-airport-option-subtitle">{airport.airportName} · {airport.countryName}</span>
                                            </span>
                                            <span className="flight-airport-option-code">{airport.airportCode}</span>
                                        </button>
                                    </li>
                                )) : <li className="flight-airport-message">No matching airports found</li>}
                            </ul>
                        )}
                    </div>
                </div>
                <div className="modify-flight-field">
                    <label htmlFor="modifyDeparture"><i className="ri-calendar-2-line" /> Depart</label>
                    <div className="input-group">
                        <Flatpickr
                            id="modifyDeparture"
                            value={departureDate}
                            onChange={date => handleDepartureDate(date)}
                            options={{ dateFormat: "d M Y", minDate: "today" }}
                            className="form-control"
                            placeholder="Choose date"
                        />
                    </div>
                </div>
                <div className={`modify-flight-field${journeyType === "ONEWAY" ? " modify-flight-return-placeholder" : ""}`}>
                    <label htmlFor="modifyReturn"><i className="ri-calendar-check-line" /> Return</label>
                    {journeyType === "RETURN" ?
                        <div className="input-group">
                            <Flatpickr
                                id="modifyReturn"
                                value={returnDate}
                                onChange={date => handleReturnDate(date)}
                                options={{ dateFormat: "d M Y", minDate: departureDate, }}
                                className="form-control"
                                placeholder="Choose date"
                            />
                        </div>
                        : <button type="button" className="modify-flight-add-return" onClick={() => setJourneyType("RETURN")}><strong>Add return date</strong><small>Save on round trips</small></button>}
                </div>
                <div className="modify-flight-field modify-flight-travellers">
                    <label htmlFor="modifyTravellers"><i className="ri-user-line" /> Travellers</label>
                    <div className="dropdown" data-bs-auto-close="outside">
                        <button className="form-control dropdown-toggle modify-flight-traveller-toggle" type="button" id="modifyTravellers" data-bs-toggle="dropdown" aria-expanded="false">
                            <strong>{adults + kids + infants} Traveller{adults + kids + infants === 1 ? "" : "s"}</strong>
                            <small>{cabinClass.replace("_", " ")}</small>
                        </button>
                        <div className="dropdown-menu p-3" aria-labelledby="modifyTravellers">
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <span>Adults</span>
                                <div className="input-step d-flex align-items-center">
                                    <button type="button" className="minus" onClick={handleDecreaseAdults}>–</button>
                                    <input type="number" className="product-quantity text-center" min="1" max="9" readOnly value={adults} name="adults" />
                                    <button type="button" className="plus" onClick={handleIncreaseAdults}>+</button>
                                </div>
                            </div>
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <span>Kids</span>
                                <div className="input-step d-flex align-items-center">
                                    <button type="button" className="minus" onClick={handleDecreaseKids}>–</button>
                                    <input type="number" className="product-quantity text-center" min="0" max="9" readOnly value={kids} name="kids" />
                                    <button type="button" className="plus" onClick={handleIncreaseKids}>+</button>
                                </div>
                            </div>
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <span>Infants</span>
                                <div className="input-step d-flex align-items-center">
                                    <button type="button" className="minus" onClick={handleDecreaseInfants}>–</button>
                                    <input type="number" className="product-quantity text-center" min="0" max="5" readOnly value={infants} name="infants" />
                                    <button type="button" className="plus" onClick={handleIncreaseInfants}>+</button>
                                </div>
                            </div>
                            <div className="mb-0">
                                <label className="form-label" htmlFor="modifyCabinClass">Cabin class</label>
                                <select className="form-select" id="modifyCabinClass" value={cabinClass} onChange={handleClassType}>
                                    <option value="ECONOMY">Economy</option>
                                    <option value="PREMIUM_ECONOMY">Premium economy</option>
                                    <option value="BUSINESS">Business</option>
                                    <option value="FIRST">First</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modify-flight-search-footer">
                <span>Update your route, dates or travellers</span>
                <button type="button" onClick={handleSearch} className="modify-flight-submit">
                    <i className="ri-search-line" aria-hidden="true" /> Search flights
                </button>
            </div>
        </section>
    );
};

export default ModifyFlightSearch;
